import { PageController } from '@client/components/_core/layout/PageController';
import { History } from '@client/components/_ui/display/History';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/mspr/service-providers/details/$id/history')({
    component: HistoryComponent,
    staticData: {
        ui: {
            useParentTitle: true,
        },
    },
});

function HistoryComponent() {
    const { id } = Route.useParams();
    return (
        <PageController route={Route}>
            <History idValue={id} idPropertyName="msprProviderId" />
        </PageController>
    );
}
